import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableSortLabel from "@mui/material/TableSortLabel";
import { Checkbox,Box,Typography } from "@mui/material";
import Pagination from '@mui/material/Pagination';
import { Constants } from '../Content';
import InputBase from "@mui/material/InputBase";
import { PaginationSection } from "../ManageDataTab/ManageDataStyled";
const PricingModelTable = ({ headers, rows, handleCheckboxChange }) => {
  const [pageNumber, setPageNumber] = useState(Constants.INITALPAGENO);
  const [rowsPerPage] = useState(Constants.PAGECOUNT);
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = useState("usage");
  const [filters, setFilters] = useState('');
  const handleChangePage = (event, newPage) => {
    setPageNumber(newPage);
  };
  const createSortHandler = (property) => (event) => {
    setOrder(order == "asc" ? "desc" : "asc");
    setOrderBy(property);
  };
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
  const handleFilterChange = (columnName, value) => {
    setFilters(value);
    setPageNumber(Constants.INITALPAGENO);
  };
  const filteredData = rows?.filter((row) =>filters!==''
  ? row.productName?.toString()?.trim()?.toLowerCase()?.includes(filters?.trim()?.toLowerCase())
  : true
  );
  const tableRows = [...filteredData];
  return (
    <div>
      <TableContainer component={Paper}>
        <Table id="datatable" aria-label="customized table">
          <TableHead>
            <TableRow>
              {headers?.map((item, index) => (
                <TableCell key={index}  className={item.id==='productName'?"fixedColumn":"checkboxColumns"}>
                  {item?.header}
                  {item?.sort && (
                    <TableSortLabel
                      active={orderBy === item.id}
                      direction={
                        orderBy === item.id ? order : Constants.DECENDING
                      }
                      onClick={createSortHandler(item.id)}
                    />
                  )}
                 { item.id==='productName' && <div key={item.id} className="filterBox">
                    <InputBase
                      className="filter"
                      placeholder='Search'
                      value={filters || ""}
                      onChange={(e) =>handleFilterChange(item.id, e.target.value)}
                    />
                  </div>}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableRows.length > 0
              ? (rowsPerPage > 0
                  ? stableSort(tableRows, getComparator(order, orderBy)).slice(
                      (Number(pageNumber) - 1) * rowsPerPage,
                      (Number(pageNumber) - 1) * rowsPerPage + rowsPerPage
                    )
                  : tableRows
                ).map((row, rowIndex) => (
                  <TableRow key={rowIndex}>
                    {headers?.map((header, cellIndex) => (
                      <TableCell key={cellIndex} size='small' className= {header.id === 'productName'?"freezeRow":""}>
                        {header.id === 'productName' ?
                        (
                          row[header.id]
                        ): (
                          <Checkbox  id={rowIndex}
                          checked={row[header.id]?row[header.id]:false} 
                          onChange={(e) => handleCheckboxChange(e,header,row)}/>
                        ) }
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              : (
                <TableRow>
                   <TableCell colSpan={6} align="center">
                      <h5>
                        {Constants.NODATATABLE}
                      </h5>
                    </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
      <PaginationSection>
        <Box className="paginationContainer">
          <Typography variant="h6">
            {tableRows.length}
            <span> {Constants.TOTAL_RESULT}</span>
          </Typography>
          <Pagination
            sx={{
              fontFamily: '"Noto Sans", sans-serif',
            }}
            count={Math.ceil(tableRows.length / rowsPerPage)}
            page={pageNumber}
            onChange={handleChangePage} // Use onChange for page changes
            // Use onRowsPerPageChange for rows per page changes
          />
        </Box>
      </PaginationSection>
    </div>
  );
};

export default PricingModelTable;
